import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import GateCard from 'components/sales/cardSection/gateCard/gateCard';
import { MrfStatus } from 'components/installation/mrfStatus/mrfStatus';
import ModalPop from 'components/sales/modal/modal';
import FormSectionNew from 'components/sales/formSection/formSectionNew';
import { Button } from 'react-bootstrap';
import Checkbox from 'components/sales/Input/checkbox/checkbox';
import DocumentView from 'components/sales/downloadDocView/documentView';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Regex from 'services/utils/regex/Regex';
import { ConsolidateReport } from 'components/installation/consolidateReport/consolidateReport';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import useLatLng from 'hooks/uselatlng/uselatlng';
import { Link } from "react-router-dom";
import './siteInspection.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import CardSectionNew from 'components/sales/cardSection/cardSection';
import FormSection from 'components/sales/formSection/formSectionNew';
import TableSection from 'components/sales/tableSection/tableSection';
import ProductInventory from "components/sales/formSection/productInventory/productInventorySolution";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from 'components/sales/divLayout/divLayout';
import Milestone from './milestoneSiteInspection';
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import InvoiceModule from 'components/sales/formSection/materialHardware/invoiceModuleInspection';


const SiteInspectionDetails = ({
  inspectionApprovalDetails,
  siteData,
  match,
  history,
  getLocationApprovalPending,
  location,
  getPocBySiteId,
  getCheckLocation,
  getInventory,
  inspectionPostSolution,
  inspectionReject,
}) => {
  const islatlng = useLatLng();
  const [modalFlag, setModalFlag] = useState(null);
  const [isModal, setIsModal] = useState(null);
  const [modalMsg, setModalMsg] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [generateFlag, setGenerateFlag] = useState(false);
  const [mrfReportModal, setMrfReportModal] = useState(false);
  const [generateReportFlag, setGenerateReportFlag] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [poclist, setPocList] = useState([]);
  const [modal, setModal] = useState(false);
  const [showOtherEmail, setShowOtherEmail] = useState(false);
  const [checkMismatch, setCheckMismatch] = useState(1);
  const [mailList, setMailList] = useState([]);
  const [otherEmail, setOtherEmail] = useState();
  const [milestoneData, setMilestoneData] = useState(null);
  const [milestone, setMilestone] = useState(null);
  const [InvoiceModuleData, setInvoiceData] = useState(null);
  const [invoiceDatas, setInvoiceDatas] = useState(null);

  const { baseUrl } = useContext(BaseUrl);
  const [inventoryForm, setInventoryForm] = useState({
    comm_id: "",
    current_setup_id: "",
    id: "",
    gate_amount: ""
  });

  const [commData, setComm] = useState({
    total_mg_amount: "",
    subscription_amount: "",
    installation_amount: "",
  });


  useEffect(() => {
    if (
      inspectionApprovalDetails !== null &&
      match.params.id
    )
      (async () => {
        setIsLoading(true);
        await inspectionApprovalDetails(match.params.id, match.params.stageId);
        setIsLoading(false);
      })();
  }, [inspectionApprovalDetails, match.params.id]);

  const handleModalHide = () => setModalFlag(null);



  useEffect(() => {

    if (
      siteData?.solution !== undefined &&
      siteData?.solution !== null
    ) {
      const tagData = siteData.solution;

      setTimeout(() => {
        if (tagData != '') {
          setInventoryForm(tagData);
        }
      }, 100);
      if (siteData?.milestones) {
        setMilestoneData(siteData?.milestones);
      }
      if (siteData?.invoice_module) {
        setInvoiceDatas(siteData?.invoice_module);
      }
    }
    if (siteData && siteData.lead_comm) {
      setComm({
        total_mg_amount: siteData.lead_comm.total_mg_amount,
        subscription_amount: siteData.lead_comm.subscription_amount,
        installation_amount: siteData.lead_comm.installation_amount,
      })
    }
  }, [siteData]);

  const handleMileStone = (val) => {
    setMilestone(val);
  };
  const handleInvoiceData = (val) => {
    setInvoiceData(val);
  };

  const finalSubmit = async (inspection_id) => {
    if (inspection_id) {
      const data = {
        inv_data: inventoryForm,
        commData: commData,
        inspection_id: match.params.id,
      };

      // if (InvoiceModuleData !== null && InvoiceModuleData != undefined) {
      //   let subsAmt = Number(commData?.subscription_amount);
      //   let invoiceAmt = InvoiceModuleData?.invoiceAmt;
      //   console.log(subsAmt);
      //   console.log(invoiceAmt);
      //   const initialValue = 0;
      //   const sumWithInitial = invoiceAmt.reduce(
      //     (previousValue, currentValue) => previousValue + currentValue,
      //     initialValue
      //   );
      //   console.log(sumWithInitial);
      //   if (subsAmt === sumWithInitial) {
      //     data.InvoiceModuleData = InvoiceModuleData;
      //   } else {
      //     toast.error('Total amount of invoice module is not equal to the total subscription amount!');
      //     return;
      //   }


      // }

      // if (milestone != null) {
      //   let totalAmt = parseInt(commData?.total_mg_amount);
      //   let calculatedAmt = 0;
      //   if (!isNaN(totalAmt)) {
      //     if (totalAmt > 0) {
      //       for (let i = 0; i < milestone.milestone_data.length; i++) {
      //         if (milestone.milestone_data[i].amt) {
      //           calculatedAmt += parseInt(milestone.milestone_data[i].amt);
      //         }
      //       }
      //       for (let i = 0; i < milestone.date_invoices_data.length; i++) {
      //         if (milestone.date_invoices_data[i].amt) {
      //           calculatedAmt += parseInt(milestone.date_invoices_data[i].amt);
      //         }
      //       }
      //       for (let i = 0; i < milestone.retention.length; i++) {
      //         if (milestone.retention[i].amt) {
      //           calculatedAmt += parseInt(milestone.retention[i].amt);
      //         }
      //       }
      //       if (calculatedAmt > totalAmt) {
      //         toast.error('Milestone total amount is greater then capex amount!');
      //         return;
      //       } else {
      //         data.milestone = milestone;
      //       }
      //     }
      //   }
      // }
      setModalMsg('Approved!');
      // console.log(data); return false;
      setIsLoading(true);
      const res = await inspectionPostSolution(data);
      setIsLoading(false);
      // console.log(res);
      if (res) {
        setIsModal(true);
      }
    }

  }

  const submitForReject = async (inspection_id) => {

    if (inspection_id) {
      const data = {
        inspection_id: match.params.id,
      };
      setModalMsg('Rejected!');
      setIsLoading(true);
      const res = await inspectionReject(data);
      setIsLoading(false);
      // console.log(res);
      if (res) {
        setIsModal(true);
      }
    }

  }

  const handleInputChange = (e, index) => {
    // console.log(e);
    const { name, value } = e.target;
    const list = [...inventoryForm];
    list[index][name] = value;
    setInventoryForm(list);
  };
  const handleMgChange = (e) => {
    // console.log(e);
    const { name, value } = e.target;
    const list = [...commData];
    // console.log(list); 
    list[0][name] = value;
    setComm(list);
  };
  const handleSubChange = (e) => {
    // console.log(e);
    const { name, value } = e.target;
    const list = [...commData];
    // console.log(list); 
    list[0][name] = value;
    setComm(list);
  };


  return (
    <Layout
      title={`Site Inspection Material Mapping`}
      status={location.state && location.state.status}
      isGoback
      isLoading={isLoading}
      linkFlag={true}
      linkUrl={`/dashboard/inspection_approvals`}
    >
      {siteData && siteData.details &&
        <>
          <div className='col-md-12'>
            <h4>{siteData.details.client_name} ({siteData.details.site_no})</h4>
            <hr />
          </div>
        </>
      }

      {/* CAPEX INVOICE */}
      {
        siteData?.details?.commercial_type_id == 5 && siteData?.capex_invoicing_details && typeof siteData?.capex_invoicing_details === 'object' && !Array.isArray(siteData?.capex_invoicing_details) && Object.keys(siteData?.capex_invoicing_details).length > 0 &&
        <>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-12' style={{ marginBottom: '10px' }}>
                <span><b>Contract Amount :</b> &nbsp;₹&nbsp;
                  {(parseFloat(siteData?.hardware_amount) + parseFloat(siteData?.details?.installation_amount) + parseFloat(siteData?.details?.cartage_amount) + parseFloat(siteData?.tags_amount)).toFixed(2)}
                </span>
              </div>
            </div>

            <div className='row' style={{ marginBottom: '10px' }}>
              <div className='col-md-3'>
                <span><b>Hardware Amount :</b> &nbsp;₹&nbsp;
                  {siteData?.hardware_amount}
                </span>
              </div>
              <div className='col-md-3'>
                <span><b>Installation Amount :</b> &nbsp;₹&nbsp;
                  {siteData?.details?.installation_amount}
                </span>
              </div>
              <div className='col-md-3'>
                <span><b>Cartage Amount :</b> &nbsp;₹&nbsp;
                  {siteData?.details?.cartage_amount}
                </span>
              </div>
              <div className='col-md-3'>
                <span><b>Tags Amount :</b> &nbsp;₹&nbsp;
                  {siteData?.tags_amount}
                </span>
              </div>
            </div>
            <hr />
          </div>
        </>
      }
      
      {/* Hardware Requirement */}
      <div className='col-md-12'>
        <FormSection title={'Requirement'}>
          <div className="details-listing">
            {siteData && siteData.categories &&
              <>
                <table style={{ border: '1px solid', width: '100%' }}>
                  <tr style={{ border: '1px solid', backgroundColor: '#2f80ed', color: '#fff' }}>
                    <th style={{ border: '1px solid', padding: '6px' }}>Category</th>
                    <th style={{ border: '1px solid', padding: '6px' }}>Ops Qty</th>
                    <th style={{ border: '1px solid', padding: '6px' }}>Sales Qty</th>
                  </tr>

                  {siteData.categories.map((obj, index) => {
                    return (
                      <Fragment key={index}>
                        {obj.operation_quantity === obj.sale_quantity ?
                          <tr key={index}>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.category_name}</td>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.operation_quantity}</td>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.sale_quantity}</td>
                          </tr>
                          :
                          <tr key={index} style={{ "backgroundColor": "#ffe6e6" }}>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.category_name}</td>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.operation_quantity}</td>
                            <td style={{ border: '1px solid', padding: '6px' }}>{obj.sale_quantity}</td>
                          </tr>
                        }

                        {/* {console.log(obj)} */}

                      </Fragment>

                    );

                  })}
                </table>
              </>

            }
          </div>
        </FormSection>
        <hr />
      </div>
      
      {/* COMMERCIAL */}
      {/* <div className='col-md-12'>
        <FormSection title={`Commercial`}>
          {siteData && siteData.lead_comm ?
            <>
              {siteData.lead_comm && siteData.lead_comm.commercial_type_id === 5 ?
                <>
                  <ConstantInput
                    label={`Total Amount`}
                    errorMsg={localization.total_mg_amount}
                    required
                    isStarRequired={true}
                    value={commData.total_mg_amount}
                    type="number"
                    handleChange={(val) =>
                      setComm({
                        ...commData,
                        total_mg_amount: val,
                      })
                    }
                  />
                </>
                :
                <>
                  <ConstantInput
                    label={`Subscription Amount`}
                    errorMsg={localization.subscription_amount}
                    required
                    isStarRequired={true}
                    type="number"
                    value={commData.subscription_amount}
                    handleChange={(val) =>
                      setComm({
                        ...commData,
                        subscription_amount: val,
                      })
                    }
                  />
                </>
              }
            </>
            :
            null
          }
          <ConstantInput
            label={`Installation Amount`}
            errorMsg={localization.installationAmount}
            required
            isStarRequired={true}
            type="number"
            value={commData.installation_amount}
            handleChange={(val) =>
              setComm({
                ...commData,
                installation_amount: val,
              })
            }
          />
        </FormSection>
        <hr/>
      </div> */}
      
      {/* Contract Solution */}
      {siteData &&
        siteData.solution &&
        siteData.solution.length > 0 &&
        <>
          <div className='col-md-12'>
            {siteData.solution.map((obj, index) => {
              return (
                <div key={{ index }}>
                  <FormSection
                    title={`Solution ` + obj.gate_no}
                  >
                    <div className="details-listing">
                      <DivLayout
                        heading={localization.currentSetup}
                        data={
                          obj?.setupName
                            ? obj.setupName
                            : localization.na
                        }
                      />


                      <DivLayout
                        heading={localization.hardwareDtl}
                        data={
                          obj?.hardware_details
                            ? obj.hardware_details
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={localization.internetAvailabilty}
                        data={
                          obj?.internet_availability
                            ? obj.internet_availability
                            : localization.na
                        }
                      />
                      <DivLayout
                        heading={`Gate Amount`}
                        data={
                          obj?.gate_amount
                            ? obj.gate_amount
                            : localization.na
                        }
                      />
                      {/* <div className={'form-group'}>
                        <input
                          className="form-control indianrupee prefix-text"
                          type="number"
                          name="gate_amount"
                          placeholder="Unit Price"
                          value={obj.gate_amount}
                          onChange={e => handleInputChange(e, index)}
                        />
                        <label className="placeholder">
                          Amount
                          <span className="label-star" style={{ color: 'red' }}>
                            *
                          </span>
                        </label>
                        <span className="prefix">{'₹'}</span>
                      </div> */}
                      {/* <div>
                                  
                                    <ConstantInput
                                      label={localization.amount}
                                      className="indianrupee"
                                      isPrefix
                                      prefixText={'₹'}
                                      type="number"
                                      // value={locationData.billGeoState}
                                      handleChange={(val,obj) => {
                                        setInventoryForm({
                                          ...inventoryForm,
                                          amount: val,
                                          gate_id: obj,
                                        });
                                      }}
                                      value={obj.gate_amount}
                                    />
                                </div> */}
                    </div>

                  </FormSection>
                </div>
              );
            })}
            <hr />
          </div>
        </>
      }

      {/* INVOICE */}
      {/* {siteData.lead_comm && siteData.lead_comm.commercial_type_id === 7 &&
        <>
          <div className='col-md-12'>
            <FormSection title={`Commercial`}>
              <InvoiceModule
                handleValue={handleInvoiceData}
                data={siteData}
                prefilledData={siteData}
                invoiceAmtData={siteData}
              />
            </FormSection>
            <hr />
          </div>
        </>
      } */}
      
      {/* MILESTONE */}
      {/* {(siteData && siteData.details && siteData.details.commercial_type_id == 5) && milestoneData != null &&
        <>
          <div className='col-md-12'>
            <Milestone
              handleValue={handleMileStone}
              prefilledData={milestoneData}
            />
          </div>
        </>
      } */}

      <br/>

      {/* Approval or Rejection */}
      {(siteData && siteData.details && siteData.details.status === 0) ?
        <>

          <div className='col-md-12'>
            <Button
              className={`mb-4`}
              onClick={() => {
                finalSubmit(match.params.id)
              }}
            >
              Approve
            </Button>

            <Button
              className={`ml-4 mb-4`}
              onClick={() => {
                submitForReject(match.params.id)
              }}
            >
              Reject
            </Button>

          </div>

        </>
        :
        (siteData && siteData.details && siteData.details.status === 1) ?
          <div className='col-md-12'>
            <h3 style={{ "color": "green" }}>Approved</h3>

          </div>
          :
          <div className='col-md-12'>
            <h3 style={{ "color": "Red" }}>Rejected</h3>

          </div>
      }

      {/* </div> */}
      <ModalPop
        title={`Final Submitted`}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <>
            {/* inspection_approvals */}
            <h5>{modalMsg}</h5>
            <Link
              to={`${baseUrl}/inspection_approvals`}
              className="btn btn-primary mb-4"
            >
              {localization.viewSiteInformation}{" "}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          </>
        </div>
      </ModalPop>



    </Layout>
  );
};
export default SiteInspectionDetails;
